module.exports = __webpack_public_path__ + "static/media/love-letter-generator.89743651.png";